import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HttpModule} from "@angular/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppComponent} from "./app.component";
import {TransferHttpModule} from "../modules/transfer-http/transfer-http.module";
// RxJS
import "rxjs";
import {AppRoutingModule, routedComponents} from "./app-routing.module";
import {LoginModule} from "./shared/login/login.module";
import {StickyHeaderModule} from "./shared/sticky-header/sticky-header.module";
import {DecoratorModule} from "./shared/decorator/decorator.module";
import {ArticleUtils} from "../../common/utils/articleutils";
import {InfiniteScrollModule} from "angular2-infinite-scroll";
import {ChunksPipe} from "./shared/pipes/chunks-pipe";
import {SafePipe} from "./shared/pipes/safe-pipe";
import {NumberRangePipe} from "./shared/pipes/range-pipe";
import {MenuComponent} from "./shared/menu/menu.component";
import {SubscribeModule} from "./shared/subscribe/subscribe.module";
import {CostGuideUtils} from "../../common/utils/costguideutils";
import {StringUtils} from "./shared/services/stringutils";
import {UnescapeCachePipeModule} from "./shared/pipes/unescape-cache-pipe";
import {SectionCategoryModule} from "./category/section/section-category.module";
import {ShareButtonsDirective} from "./shared/directives/article/directives/share-buttons.directive";
import {DynamicTypeBuilder} from "./shared/type-builder/type.builder";
import {BrowserModule} from "@angular/platform-browser";
import {HeroAnimationService} from "./shared/animations/hero-animation.service";
import {ArticleContentComponent} from "./article/articlecontent/articlecontent.component";
import {NouisliderModule} from "ng2-nouislider";
import {CityUtils} from "../../common/utils/cityutils";
import {ProfessionCategoriesUtils} from "../../common/utils/professioncategoriesutils";
import {MapUrlUtils} from "../../common/utils/mapurlutils";
import {CensusTractsTilesUtils} from "../../common/utils/censustractstilesutils";
import {AffordabilityUtils} from "../../common/utils/affordabilityutils";
import {HrefDirective} from "./shared/directives/article/directives/href.directive";
import {CostOfLivingUtils} from "../../common/utils/costoflivingutils";
import {KeysPipe} from "./shared/pipes/key-pipe";
import {TaxesUtils} from "../../common/utils/taxesutils";
import {Aot2JitSharingService} from "./shared/services/aot2jitsharing.service";

@NgModule({
	imports: [
    BrowserModule.withServerTransition({
      appId: 'howmuch'
    }),
    CommonModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    TransferHttpModule,
    AppRoutingModule,
    LoginModule,
    DecoratorModule,
    StickyHeaderModule,
    InfiniteScrollModule,
    SubscribeModule,
    SectionCategoryModule,
    UnescapeCachePipeModule,
    NouisliderModule
  ],
  providers: [
    ArticleUtils,
    CostGuideUtils,
    StringUtils,
    DynamicTypeBuilder,
    HeroAnimationService,
    CityUtils,
    ProfessionCategoriesUtils,
    MapUrlUtils,
    CensusTractsTilesUtils,
    AffordabilityUtils,
    CostOfLivingUtils,
    TaxesUtils,
    Aot2JitSharingService
  ],
	declarations: [
	  AppComponent,
    routedComponents,
    ArticleContentComponent,
    ChunksPipe,
    SafePipe,
    NumberRangePipe,
    KeysPipe,
    MenuComponent
  ],
  exports: [
    AppComponent
  ]
})

export class AppModule {}




// WEBPACK FOOTER //
// ./src/app/app.module.ts